export default __webpack_public_path__ + "static/media/history-clock-button.33fe906a.svg";